import { Link } from 'react-router-dom';
import { useLang } from '@/hooks/useLang';
import { uiContent } from '@/data/ui';
import { articles } from '@/data/articles';
import { MAIN_SITE_URL } from '@/data/categories';
import LanguageSwitcher from './LanguageSwitcher';
import { getArticleTitle } from '@/data/articles/content';

export default function Footer() {
  const lang = useLang();
  const t = uiContent[lang];

  const resourceLinks = articles.slice(0, 5).map((a) => ({
    slug: a.slug,
    label: getArticleTitle(a.slug, lang),
  }));

  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="text-base font-bold text-foreground-900 font-heading">AllChinaBuy Spreadsheet</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600">{t.footer.disclaimerText}</p>
            <div className="mt-5">
              <LanguageSwitcher />
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">
              <Link to="/" className="hover:text-primary-700">{t.nav.guides}</Link>
            </h4>
            <ul className="mt-4 space-y-2">
              {resourceLinks.map((r) => (
                <li key={r.slug}>
                  <Link to={`/article/${r.slug}`} className="text-sm text-foreground-600 transition hover:text-primary-700">
                    {r.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">{t.footer.explore}</h4>
            <ul className="mt-4 space-y-2">
              <li><a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 transition hover:text-primary-700">{t.footer.visitMain}</a></li>
              <li><Link to="/" className="text-sm text-foreground-600 transition hover:text-primary-700">{t.breadcrumbHome}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">{t.footer.about}</h4>
            <ul className="mt-4 space-y-2">
              <li><span className="text-sm text-foreground-600">{t.footer.editorial}</span></li>
              <li><span className="text-sm text-foreground-600">{t.footer.disclaimer}</span></li>
              <li><span className="text-sm text-foreground-600">{t.footer.affiliate}</span></li>
              <li><span className="text-sm text-foreground-600">{t.footer.privacy}</span></li>
              <li><span className="text-sm text-foreground-600">{t.footer.terms}</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} AllChinaBuy Spreadsheet. {t.footer.copyright}</p>
          <p className="text-xs text-foreground-500">{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}